export default __webpack_public_path__ + "static/media/lb-pp.94b4f005.webp";